// ======================================================================
// File: IndentReferencePopover.jsx
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Show indent → quantity mapping for a PR line
// - Read-only traceability
// ======================================================================

import React, { useEffect, useState } from "react";
import purchaseRequestService from "../services/purchaseRequestService";

export default function IndentReferencePopover({
  prId,
  prLineId
}) {

  const [open, setOpen] = useState(false);
  const [refs, setRefs] = useState([]);

  useEffect(() => {
    if (open) {
      loadReferences();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const loadReferences = async () => {
    try {
      const res =
      await purchaseRequestService.getPurchaseRequestById(
        prId
      );
      const lines = res?.data?.data?.lines || [];
      const line = lines.find((l) => l.id === prLineId);

      setRefs(line?.indent_refs || []);
    } catch (err) {
      console.error("Failed to load indent references", err);
    }
  };

  return (
    <div className="indent-ref-popover">
      <button
        className="link-btn"
        onClick={() => setOpen(!open)}
      >
        View
      </button>

      {open && (
        <div className="popover-content">
          <strong>Indent References</strong>

          {refs.length === 0 && (
            <div>No indent references</div>
          )}

          {refs.map((r, idx) => (
          <div key={idx}>
            {r.indent_no}
            {" → "}
            Qty: {r.indent_qty}
          </div>
        ))}
        </div>
      )}
    </div>
  );
}
